export const home = {
  hero: {
    pill: {
      label: 'Consumenten',
      text: 'Bestel nu eten'
    },

    heading: {
      serve: 'Serveer',
      more_orders: 'meer orders',
      to_your_restaurant: 'in jouw restaurant met Bistroo',
    },

    saving_time: 'We besparen je tijd en verhogen je winst.',
    boosting_business: 'We boosten jouw online business.',

    header_mockup_alt: 'Dashboard & Landingspagina',
    partners_alt: 'Vertrouwd door onze partners'
  },
  landing_pages: {
    heading: {
      create: 'Maak',
      your_restaurant: 'een website of webshop',
      shop_in_minutes: 'voor jouw restaurant in enkele minuten'
    },

    personalized_webshop: 'Een gepersonaliseerde webshop en website voor jouw restaurant, binnen no-time online.',
    start_free: 'Start vandaag gratis en kies uit 1000+ aanpasbare ontwerpen.',

    actions: {
      create_your_website: 'Maak je website',
    }
  },
  key_features: {
    pill: {
      label: 'Belangrijkste functies',
      text: 'Alles wat je moet weten',
    },

    heading: 'Alles wat je nodig hebt voor online bestellen',

    personalize_order_experience: 'Personaliseer de bestelervaring van je klanten met ons volledig aanpasbare online',
    boost_sales: 'bestelsysteem. Ontdek de tools om jouw restaurant te laten groeien terwijl je kosten bespaart.',

    cards: {
      order_management_with_ease: {
        title: 'Eenvoudig orderbeheer.',
        text: 'Bied je klanten een gepersonaliseerde bestelervaring met ons volledig zelf configureerbare online webshop manager.',
        button: 'Bekijk de manager'
      },
      plug_and_play: {
        title: 'Plug-and-play.',
        text: 'Start binnen enkele minuten met ons POS-device of gebruik je eigen telefoon of laptop.'
      },
      peak_times: {
        title: 'Beheer drukke piekmomenten.',
        text: 'Pas instellingen in realtime aan.'
      },
      instant_payments: {
        title: 'Directe betalingen.',
        text: 'Betaal bestellingen op elk moment uit.',
        img_alt: 'POS handheld'
      },
      many_more: {
        title: 'En nog veel meer!',
        text: 'Wil je meer details over de beste functies?',
        button: 'Bekijk alle functies',
      }
    }
  },
  products: {
    pill: {
      label: 'Bistroo Producten',
      text: 'Alles wat we bieden',
    },
    heading: 'Kies de oplossingen die perfect passen in het recept van jouw bedrijf',
    stop_overspending: 'Stop met te veel betalen voor dure software vol ongebruikte functies, bespaar kosten en verhoog de efficiëntie.',
    productivity_increase: 'We zien gemiddeld een stijging van 20% in productiviteit en omzet bij optimaal gebruik van onze oplossingen.',
    start_for_free: 'Start nu gratis',

    cards: {
      bistroo: 'Bistroo',
      webshop: {
        title: 'Webshop',
        description: 'Een op maat gemaakte webshop gericht op restaurants, met een uitgebreide beheermodule.',
        img_alt: 'Bistroo Webshop',
        features: [
          'In de stijl van jouw restaurant',
          'Binnen een paar minuten geregeld',
          'Volledig eigen controle'
        ],
        action: 'Bekijk Webshop'
      },
      page: {
        title: 'Page',
        description: 'Geen tijd of kennis om een eigen website te maken? De Page is beveiligd en beheerd voor een scherpe prijs.',
        img_alt: 'Bistroo Pagina',
        features: [
          'In de stijl van jouw restaurant',
          'Eigen domein inclusief hosting',
          'Verbonden met je webshop',
        ],
        action: 'Bekijk Page'
      },
      qr: {
        title: 'QR',
        description: 'Bestellingen aannemen was nog nooit zo makkelijk. Laat gasten eenvoudig bestellen via hun telefoon.',
        img_alt: 'Bistroo QR',
        features: [
          'Verhoog omzet op je terras',
          'Incl. weerbestendige QR-stickers',
          'Directe betalingen',
        ],
        action: 'Bekijk QR'
      }
    }
  },
  integrations: {
    heading: 'Gebruik plug-and-play integraties',
    text: 'Beheer en optimaliseer online bestellingen door integraties met jouw favoriete tools en kassasystemen. Wij hebben het voorbereid, koppel simpelweg wat je nodig hebt! Zo eenvoudig is het.',
    action: 'Bekijk integraties'
  },
  testimonials: {
    pill: {
      label: 'Klantverhalen',
      text: 'Wat ondernemers zeggen'
    },

    heading: 'Deze ondernemers maken al gebruik van Bistroo en zeggen..',
    empowered_our_clients: 'Ontdek hoe onze oplossingen ondernemers succes hebben gebracht!',

    testimonials: {
      hero: {
        img_alt: 'Mondie Scheepers - Two-B by Mondie',
        text: '"Bistroo bespaart ons dagelijks veel tijd en vermindert de frustratie bij onze klanten, tevens zien we een stijging in afhaalbestellingen."',
        author: 'Mondie Scheepers',
        company: 'Two-B by Mondie',
        action: 'Lees het volledige verhaal'
      },

      reviews: {
        one: {
          text: '"Met de overstap naar Bistroo hoeven we niet langer telefonische bestellingen aan te nemen, waardoor we kostbare tijd besparen en meer ruimte hebben voor de service aan onze klanten."',
          author: 'Roberta',
          company_role: 'Gastvrouw, Il Municipio',
          action: 'Lees verhaal',
        },
        two: {
          text: '"Met Bistroo besparen we al gauw meer dan 250 euro per maand. Tevens door promotie zagen we meer klanten via Bistroo binnenkomen. Dit is voor ons gunstig aangezien deze bestellingen een stuk goedkoper zijn qua kosten."',
          author: 'Hamza',
          company_role: 'Eigenaar, Grillroom Istanbul',
          action: 'Lees verhaal',
        },
        three: {
          text: '"Dankzij Bistroo hebben we meer regie over drukke momenten. Voorheen werden telefonische bestellingen soms niet aangenomen, wat mogelijk omzetverlies veroorzaakte. We zien dit duidelijk terug in onze cijfers."',
          author: 'Henk Boom',
          company_role: 'Eigenaar, cafetaria D\'n Boom',
          action: 'Lees verhaal',
        }
      }
    }
  }
}